import { Component } from '@angular/core';
import { ToastService } from '../../services/toast.service';
import { ToastType } from 'src/app/models/enums/Toast.enum';


@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
  standalone: false,
})
export class ToastComponent {

  constructor(public toastService: ToastService) { }

  getToastClass(type: ToastType): string {
    switch (type) {
      case ToastType.Success: {
        return "Success";
      }
      case ToastType.Error: {
        return "Error";
      }
      case ToastType.Info: {
        return "Info";
      }
      default: return "";
    }
  }
}
